"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SelectField = _interopRequireDefault(require("material-ui/SelectField"));
var _MenuItem = _interopRequireDefault(require("material-ui/MenuItem"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./Select.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);
  var _super = _createSuper(Select);
  function Select(props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, props);
    _this.state = {
      selected: _this.props.selected || 0,
      value: _this.props.value
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Select, [{
    key: "handleChange",
    value: function handleChange(event, index, value) {
      // we store the index but pass the value
      this.setState({
        selected: index,
        value: value
      });
      if (typeof this.props.onChange !== "undefined") {
        // @TODO Remove dependency with dataProperty, 'name' is more appropriate.
        var name = this.props.dataProperty || this.props.name;
        this.props.onChange(name, value);
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      if (this.state.selected !== this.props.selected && this.props.needRefresh) {
        this.setState({
          selected: this.props.selected,
          value: this.props.value
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProp) {
      if (prevProp.value !== this.props.value) {
        this.setState({
          value: this.props.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var inputStyle = this.props.styleName === "plain" ? {
        backgroundColor: "#f6f6f6",
        fontSize: 13,
        marginTop: 0,
        borderRadius: 4,
        width: "100%",
        height: 65,
        boxSizing: "border-box",
        padding: "0 0 0 11px"
      } : this.props.style;
      var underlineStyle = this.props.styleName === "plain" ? {
        display: "none"
      } : this.props.underlineStyle;
      var floatingLabelStyle = this.props.styleName === "plain" ? {
        top: 27,
        fontSize: 14,
        color: "rgba(0, 0, 0, 0.4)"
      } : undefined;
      var menuStyle = this.props.styleName === "plain" ? {
        marginTop: 5
      } : this.props.menuStyle;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "cms-select cms-input-text ".concat(this.props.dataProperty)
      }, this.props.label ? /*#__PURE__*/_react["default"].createElement("label", {
        className: "input-label",
        htmlFor: this.props.name,
        style: this.props.labelStyle
      }, this.props.label) : null, this.props.instructions ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "input-instructions",
        style: this.props.instructionsStyle
      }, this.props.instructions) : null, /*#__PURE__*/_react["default"].createElement(_SelectField["default"], {
        value: this.state.value,
        onChange: this.handleChange,
        hintText: this.props.hintText,
        hintStyle: this.props.hintStyle,
        key: this.props.id,
        style: inputStyle,
        underlineStyle: underlineStyle,
        floatingLabelText: this.props.floatingLabel,
        floatingLabelStyle: floatingLabelStyle,
        menuStyle: menuStyle,
        listStyle: this.props.listStyle,
        selectedMenuItemStyle: this.props.selectedMenuItemStyle,
        menuItemStyle: this.props.menuItemStyle,
        floatingLabelFixed: this.props.floatingLabel || this.props.label ? true : false,
        multiple: this.props.multiple
      }, this.props.options && this.props.options.map(function (option, index) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: index,
          value: option.value,
          primaryText: option.label.en || option.label,
          innerDivStyle: _this2.props.selectedMenuItemStyle
        });
      })));
    }
  }]);
  return Select;
}(_react.Component);
Select.defaultProps = {
  selected: 0,
  needRefresh: false,
  hintStyle: {
    bottom: 3,
    left: 20
  },
  style: {
    width: 150
  },
  underlineStyle: {
    color: "#abcdeff"
  }
};
Select.propTypes = {
  selected: _propTypes["default"].number,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].number]),
  dataProperty: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  needRefresh: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  underlineStyle: _propTypes["default"].object,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  labelStyle: _propTypes["default"].object,
  floatingLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  menuStyle: _propTypes["default"].object,
  listStyle: _propTypes["default"].object,
  selectedMenuItemStyle: _propTypes["default"].object,
  menuItemStyle: _propTypes["default"].object,
  instructions: _propTypes["default"].string,
  instructionsStyle: _propTypes["default"].object,
  options: _propTypes["default"].array,
  onChange: _propTypes["default"].func,
  name: _propTypes["default"].string
};
var _default = Select;
exports["default"] = _default;